var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 17.3186C13.6058 17.3186 17.1875 13.7369 17.1875 9.3186C17.1875 4.90033 13.6058 1.3186 9.1875 1.3186C4.76922 1.3186 1.1875 4.90033 1.1875 9.3186C1.1875 13.7369 4.76922 17.3186 9.1875 17.3186Z",
    fill: "#EE7734",
    fillOpacity: 0.4,
    stroke: "#EE7734",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7595 3.7396C15.0355 4.5216 14.0745 5.1636 12.9545 5.6116C11.7966 6.06762 10.5649 6.30726 9.3205 6.3186C8.07194 6.33799 6.83031 6.12958 5.6565 5.7036C4.5175 5.2826 3.5275 4.6646 2.7705 3.9016M15.7595 14.8976C15.0355 14.1156 14.0745 13.4736 12.9545 13.0256C11.7966 12.5696 10.5649 12.33 9.3205 12.3186C8.07194 12.2992 6.8303 12.5076 5.6565 12.9336C4.5175 13.3536 3.5285 13.9716 2.7705 14.7346M9.1875 1.3186V17.3186M17.1875 9.3186H1.1875",
    stroke: "#EE7734",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.39d0d9db0a8f99914953e2ff80deea91.svg";
export { ForwardRef as ReactComponent };